import { css } from 'styled-components';
const mixins = {
    clampTextLine: (line=3) => css`
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: ${line};
        overflow: hidden;
    `,
    h1: css`
        font-size: 20px;
        font-weight: 600;
        line-height: calc(22.4 / 14);
        margin: 0;
        color: #000;
    `,
    h2: css`
        font-size: 18px;
        font-weight: 600;
        line-height: calc(22.4 / 14);
        margin: 0;
        color: #000;
    `,
    h3: css`
        font-size: 16px;
        font-weight: 600;
        line-height: calc(25.6 / 16);
        color: #000;
        margin: 0;
    `,
    h4: css`
        font-size: 14px;
        font-weight: 600;
        line-height: calc(19.6 / 14);
        color: #000;
        margin: 0;
    `,
    h6: css`
        font-size: 14px;
        line-height: calc(16 / 10);
        font-weight: 400;
        color: #000;
        margin: 0;
    `,

    body2: css`
        font-size: 14px !important;
        font-weight: 400;
        line-height: calc(22.4 / 14);
    `,

    body3: css`
        font-size: 12px !important;
        font-weight: 400;
        line-height: calc(16.8 / 12);
    `,

    body4: css`
        font-size: 8px !important;
        font-weight: 400;
        line-height: calc(22.4 / 14);
    `,

    body5: css`
        font-size: 7px !important;
        font-weight: 400;
        line-height: calc(9.1 / 7);
    `,

    caption: css`
        font-size: 10px !important;
        font-weight: 400;
        line-height: calc(14 / 10);
    `,
}

export default mixins;